import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import SchemaMarkup from './components/seo/SchemaMarkup';
import { useTranslation } from './i18n';
import Loading from './components/common/Loading';
import HomePage from './pages/HomePage';
import LegalPage from './pages/LegalPage';
import LogoPage from './pages/LogoPage';

const App: React.FC = () => {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.dir();
  }, [i18n.language]);

  return (
    <HelmetProvider>
      <SchemaMarkup />
      <Suspense fallback={<Loading />}>
        <Router>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/logo" element={<LogoPage />} />
          </Routes>
        </Router>
      </Suspense>
    </HelmetProvider>
  );
};

export default App;